import React from "react";
import { Stack, FormControlLabel, Switch, SwitchProps, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { globalTheme } from "../../styles";

interface ToggleSwitchProps {
  isBundleView: boolean;
  onChange: (checked: boolean) => void;
}

// Custom styled Switch component
const CustomSwitch = styled((props: SwitchProps) => <Switch {...props} />)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: globalTheme.blue,
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: globalTheme.blue,
  },
}));

export const BundleViewSwitch: React.FC<ToggleSwitchProps> = ({ isBundleView, onChange }) => {
  return (
    <Stack direction="row" justifyContent="flex-end">
      <FormControlLabel
        control={<CustomSwitch checked={isBundleView} onChange={() => onChange(!isBundleView)} />}
        label={
          <Typography variant="caption" color={globalTheme.blue}>
            Bundle View
          </Typography>
        }
      />
    </Stack>
  );
};
